import { enumElementDrawStates, enumImageIndex } from "../constants";
import { DetermineTextColor } from "../utils/DetermineTextColor";
import { shadeColor } from "../utils/shadeColor";
import { uFramelessPanelColor } from "../whitelabel/brand";
import { Globals } from "./Globals";
import { QElement } from "./QElement";
import { doDrawImage } from "../utils/doDrawImage.js";

export class QImageElement extends QElement {
  constructor() {
    super();
    this.fOffscreenBuffer = null;
    this.fAcceptsClicks = false;
  }

  SetImage(theImage) {
    this.fOffscreenBuffer = theImage;
  }

  SetImageInfo(imageMgr, iconIndex, imageIndex, srcWidth, srcHeight) {
    this.fImageMgr = imageMgr;
    this.fOffscreenBuffer = this.fEnabledImage
      ? this.fEnabledImage
      : imageMgr.GetIndexImage(imageIndex);
    this.fImageRef = iconIndex;
    this.fImageFile = imageIndex;
    this.fSrcWidth = srcWidth;
    this.fSrcHeight = srcHeight;
    this.fAutoSlice = imageIndex === enumImageIndex.viewerIcons;
    this.SetDisabledImage();
  }

  SetDisabledImage() {
    var imageMgr = this.fImageMgr;
    var imageRef = this.fOffscreenBuffer;
    var disabledImageRef;
    switch (this.fImageFile) {
      case enumImageIndex.appIcons:
        break;
      case enumImageIndex.viewerIcons:
        disabledImageRef = imageMgr.fDisableImageCache[this.fImageFile];
        break;
      default:
        disabledImageRef = imageMgr.fDisableImageCache[this.fImageFile];
        if (!disabledImageRef) {
          disabledImageRef = imageMgr.ConvertToGrayscaleImage(imageRef);
          if (this.fImageFile != null)
            // if image index is not stored - we won't cache. Make sure index is assigned to the element here for performance reasons
            imageMgr.CacheGreyImage(this.fImageFile, disabledImageRef);
        }
    }

    // if grey image not found then default to regular image
    if (disabledImageRef == null) disabledImageRef = imageRef;

    this.fOffscreenBufferGrey = disabledImageRef;
  }

  AutoSize() {
    if (!this.fOffscreenBuffer) return;

    var x = this.fOffscreenBuffer.width;
    var y = this.fOffscreenBuffer.height;
    this.SizeElement(x, y);
  }

  DoRenderElement(drawBuffer) {
    if (this.fEnabledImage || !this.fOffscreenBuffer) return;

    var ctx = drawBuffer.getContext("2d");
    ctx.save();

    var nW = this.fOffscreenBuffer.width;
    var nH = this.fOffscreenBuffer.height;

    var pDrawState = this.GetParentDrawState();

    var parentElement = this.GetParentElement();
    if (!parentElement) parentElement = this;
    var imageData = this.fOffscreenBuffer;
    var drawDisabled = !parentElement.IsEnabled() && this.fOffscreenBufferGrey != null;
    if (drawDisabled) {
      imageData = this.fOffscreenBufferGrey;
    }
    if (this.fAutoSlice) {
      var n = parentElement.fNumCols;
      var imageRef = this.fImageRef;
      var y = Math.floor(imageRef / n);
      var x = imageRef % n;

      var srcWidth = this.fSrcWidth;
      var srcHeight = this.fSrcHeight;

      var dstHeight = this.fHeight;
      var dstWidth = this.fWidth;

      var imageHOffset = x * srcWidth;
      var imageVOffset = y * srcHeight;

      var labelShift = parentElement.fShowLabel ? 8 : 0;
      var xPos =
        parentElement.fHorzOffset +
        (parentElement.fCenterIcon ? Math.ceil((parentElement.fWidth - dstWidth) / 2) : 0);
      var yPos =
        parentElement.fVertOffset + Math.ceil((parentElement.fHeight - dstHeight) / 2) - labelShift;

      if (!parentElement.fDrawPad && Globals._browserStr.indexOf("IE") === -1) {
        // disable icon border in internet explorer
        var shadowBlur = 2;
        var shadowColor = DetermineTextColor(uFramelessPanelColor);
        switch (pDrawState) {
          case enumElementDrawStates.Hover:
            shadowBlur = 5;
            shadowColor = shadeColor(Globals._accountInfo.GetButtonColor(), -8);
            break;
          case enumElementDrawStates.MouseDown:
            shadowBlur = 1;
            shadowColor = shadeColor(Globals._accountInfo.GetButtonColor(), -10);
            break;
          default:
            break;
        }
        ctx.shadowBlur = shadowBlur;
        ctx.shadowColor = shadowColor;
      }
      if (drawDisabled) ctx.globalAlpha = 0.8;
      doDrawImage(
        ctx,
        imageData,
        imageHOffset,
        imageVOffset,
        srcWidth,
        srcHeight,
        xPos,
        yPos,
        dstWidth,
        dstHeight,
        true
      );
    } else {
      doDrawImage(
        ctx,
        imageData,
        0,
        0,
        nW,
        nH,
        this.fHorzOffset,
        this.fVertOffset,
        this.fWidth,
        this.fHeight
      );
    }
    ctx.globalAlpha = 1.0;
    ctx.restore();
  }
}
